import { useAlert } from 'components/alert'
import { CategoriaArquivoAtendProfEnum } from 'graphql/types.generated'
import { useAnalytics } from 'hooks/analytics/useAnalytics'
import { useCallback, useState } from 'react'

import { ANEXO_ARQUIVOS_DATABASE_ERROR_MESSAGE, ANEXO_ARQUIVOS_STORAGE_ERROR_MESSAGE } from '../model-anexoArquivos'
import { visualizarArquivoAnexado } from '../visualizarArquivoAnexado'

interface VisualizarArquivoAnexadoResult {
  handleVisualizarArquivoAnexado: (arquivoUuid: string, categoriaAnexo: CategoriaArquivoAtendProfEnum) => void
  loading: boolean
}

export const useVisualizarArquivoAnexado = (): VisualizarArquivoAnexadoResult => {
  const alert = useAlert()
  const { analytics } = useAnalytics()
  const [loading, setloading] = useState<boolean>(false)

  const handleVisualizarArquivoAnexado = useCallback(
    (arquivoUuid: string, categoriaAnexo: CategoriaArquivoAtendProfEnum) => {
      setloading(true)
      visualizarArquivoAnexado(arquivoUuid)
        .catch((error) => {
          alert(
            'danger',
            error.response?.status === 404
              ? ANEXO_ARQUIVOS_DATABASE_ERROR_MESSAGE
              : ANEXO_ARQUIVOS_STORAGE_ERROR_MESSAGE
          )
        })
        .finally(() => setloading(false))
      analytics.logEvent('visualizar_arquivo_anexado', { categoria: categoriaAnexo })
    },
    [alert, analytics]
  )

  return { handleVisualizarArquivoAnexado, loading }
}
